<div class="row" *ngFor="let flight of day?.flights">
  <div class="col-12 pl-4 pt-2">
    <span class="overview-icons">
      <app-service-icon [icon]="'plane-departure'" [customPath]="getServiceIconPath('plane-departure')"></app-service-icon>
    </span>
    <span class="text-capitalize">{{ getFlightRecap(flight) }}</span>
  </div>
</div>
